// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9f9c67fa","488":"2b65e10a","977":"c7cd3792"}[chunkId] + ".chunk.js";
};